import { X } from "lucide-react";
import { usePlausible } from "next-plausible";
import toast from "react-hot-toast";

import ShareButton from "./ShareButton";

const ReferralToast = () => {
	const _track = usePlausible();
	return (
		<div className="pointer-events-auto relative mb-5 flex w-full max-w-lg items-center rounded-lg border-2 bg-white p-6 shadow-xl md:mb-0 dark:border-slate-700 dark:bg-slate-800">
			<button
				className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
				onClick={() => {
					toast.dismiss();
				}}
			>
				<X className="h-5 w-5 rounded-full bg-gray-200 bg-opacity-30 dark:bg-gray-700" />
			</button>
			<div className="w-0 flex-1">
				<h4 className="font-medium text-gray-900 text-lg sm:text-xl dark:text-white">
					Share This Content:
				</h4>
				<p className="mt-1 text-gray-500 text-sm dark:text-gray-400">
					Anyone who joins through your shared content could earn you $50.
				</p>
			</div>
			<ShareButton className="!bg-sky-500 px-5 py-2 text-white shadow-md" />
		</div>
	);
};

export default ReferralToast;
